import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { errMsg } from "@/lib/api";
import { useAdminApi } from "@/lib/admin";

export const useLoad = (url, params) => {
  const call = useAdminApi();
  const [data, setData] = useState(null);
  const key = JSON.stringify(params || {});
  const reload = useCallback(() => call("get", url, undefined, { params: JSON.parse(key) }).then(setData).catch((e) => toast.error(errMsg(e))), [call, url, key]);
  useEffect(() => {
    reload();
  }, [reload]);
  return [data, reload];
};

export const PageHead = ({ title, children }) => (
  <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
    <h1 className="font-display text-2xl font-bold tracking-tight sm:text-3xl">{title}</h1>
    <div className="flex flex-wrap gap-2">{children}</div>
  </div>
);

export const DataTable = ({ head, children, testid }) => (
  <div className="overflow-x-auto rounded-2xl border border-slate-200 bg-white" data-testid={testid}>
    <table className="w-full min-w-[720px] text-sm">
      <thead><tr className="border-b border-slate-100 bg-slate-50 text-left text-xs uppercase tracking-wider text-slate-500">{head.map((h) => <th key={h} className="px-4 py-3 font-semibold">{h}</th>)}</tr></thead>
      <tbody className="divide-y divide-slate-100">{children}</tbody>
    </table>
  </div>
);

export const Td = ({ children, className = "" }) => <td className={`px-4 py-3 align-top ${className}`}>{children}</td>;

export const NativeSelect = ({ value, onChange, options, testid, placeholder }) => (
  <select value={value} onChange={(e) => onChange(e.target.value)} className="h-9 rounded-md border border-input bg-white px-3 text-sm" data-testid={testid}>
    {placeholder !== undefined && <option value="">{placeholder}</option>}
    {options.map((o) => (Array.isArray(o) ? <option key={o[0]} value={o[0]}>{o[1]}</option> : <option key={o} value={o}>{o}</option>))}
  </select>
);
